"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _EDSContext = require("../EDSContext/EDSContext");
/**
 * Context provided by the EDSApplication component is required for hook to work
 *
 * The returned locale will always use dashes as separators.
 *
 * @returns {Object: {dir: string, locale: string, platform: string}} the context object generated by EDSApplication
 */
var useEDSInfo = function useEDSInfo() {
  var edsContext = (0, _react.useContext)(_EDSContext.EDSContext);
  var dir = edsContext.dir,
    locale = edsContext.locale,
    platform = edsContext.platform;
  return {
    dir: dir,
    locale: locale,
    platform: platform
  };
};
var _default = exports.default = useEDSInfo;